import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e45016a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "createBlockedFormMainContainer" };
const _hoisted_2 = { class: "myt-2 mb-4" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bookAppointmentLabel" }, "User/Calendar", -1));
const _hoisted_5 = { class: "mb-4" };
const _hoisted_6 = { class: "bookAppointmentLabel" };
const _hoisted_7 = { class: "bookAppointmentLabel" };
const _hoisted_8 = { class: "bg-gray-50 py-4 px-3 rounded-lg mb-3" };
const _hoisted_9 = { class: "bookAppointmentLabel" };
const _hoisted_10 = { class: "mt-4 flex gap-4" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mb-2 text-sm text-gray-700" }, "Start Time", -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mb-2 text-sm text-gray-700" }, "End Time", -1));
import AppState from '@/states/book_appointment';
import { UIDatepicker, UIInput, UISelect } from '@gohighlevel/ghl-ui';
import moment from 'moment-timezone';
import { computed, onMounted } from 'vue';
import { appointmentWizardState, computedTimezonesNew, getLocationTzTimezone, selectedCalendar, updateEndTime, updateStartTime, } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateBlockedTimeForm',
    setup(__props) {
        onMounted(() => {
            var _a, _b;
            const loggedInUser = AppState.loggedInUserDetail;
            const assigned_data_only = (_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.permissions) === null || _a === void 0 ? void 0 : _a.assignedDataOnly;
            if (assigned_data_only) {
                const _users = AppState.users.filter(user => user.id === loggedInUser.id);
                appointmentWizardState.isUserSelected = true;
                appointmentWizardState.selectedUser = _users[0].id;
            }
            else if (AppState.isCalendarEvent &&
                !AppState.calendarPageData.isUserCalendar &&
                !((_b = selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.isV3Calendar)) {
                appointmentWizardState.isUserSelected = false;
                appointmentWizardState.blockedSelectedCalendarId =
                    appointmentWizardState.selectedCalendarId;
            }
            else {
                const _users = AppState.users.sort((a, b) => a.name.localeCompare(b.name));
                if (_users.length) {
                    appointmentWizardState.isUserSelected = true;
                    appointmentWizardState.selectedUser = appointmentWizardState.selectedUser
                        ? appointmentWizardState.selectedUser
                        : _users[0].id;
                }
            }
        });
        function parseDate(dateString, format) {
            return moment(dateString, format).toDate();
        }
        const blockedOffDropdownOptions = computed(() => {
            var _a;
            const loggedInUser = AppState.loggedInUserDetail;
            const assigned_data_only = (_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.permissions) === null || _a === void 0 ? void 0 : _a.assignedDataOnly;
            const _users = AppState.users;
            const _calendars = AppState.globalCalendars;
            let masterOptions = [
                {
                    type: 'group',
                    label: 'USERS',
                    key: 'users',
                    children: _users
                        .filter(user => {
                        if (assigned_data_only) {
                            return user.id === loggedInUser.id;
                        }
                        else {
                            return true;
                        }
                    })
                        .map(user => {
                        return {
                            key: 'users',
                            label: user.name,
                            value: user.id,
                            group: 'users', // Value to be used when selected
                        };
                    }),
                },
            ];
            const calendarOptions = {
                type: 'group',
                label: 'Calendars',
                key: 'calendars',
                children: _calendars
                    .filter((calendar) => !calendar.isV3Calendar)
                    .map(calendar => {
                    return {
                        key: 'calendars',
                        label: calendar.name,
                        value: calendar.id,
                        group: 'calendars',
                    };
                }),
            };
            if (!assigned_data_only) {
                masterOptions = masterOptions.concat(calendarOptions);
            }
            return masterOptions;
        });
        const setBlockedOption = (key, option) => {
            appointmentWizardState.isUserSelected = option.key !== 'calendars';
            appointmentWizardState.selectedUser = appointmentWizardState.isUserSelected
                ? option.value
                : '';
            appointmentWizardState.blockedSelectedCalendarId =
                appointmentWizardState.isUserSelected ? '' : option.value;
        };
        const inputValue = computed(() => {
            return appointmentWizardState.isUserSelected
                ? appointmentWizardState.selectedUser
                : appointmentWizardState.blockedSelectedCalendarId;
        });
        function isDateDisabled(ts, isStartDate) {
            const selectedDate = moment(ts).startOf('day');
            const currentDate = getLocationTzTimezone().startOf('day');
            const startDate = moment(appointmentWizardState.blockedOffStartTime).startOf('day');
            return isStartDate
                ? selectedDate.isBefore(currentDate)
                : selectedDate.isBefore(startDate);
        }
        function isTimeDisabled(ts, isStartDate) {
            const currentDate = getLocationTzTimezone();
            const currentHour = currentDate.hours();
            const tsDate = new Date(ts).getDate();
            const isHourDisabled = (hour) => {
                if (isStartDate) {
                    return currentDate.date() === new Date(ts).getDate() && hour < currentHour;
                }
                else {
                    const startHour = new Date(appointmentWizardState.blockedOffStartTime).getHours();
                    const startDate = new Date(appointmentWizardState.blockedOffStartTime).getDate();
                    if (tsDate === startDate) {
                        return hour < startHour;
                    }
                    return false;
                }
            };
            return { isHourDisabled };
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('appointmentModal.vacation_message')), 1),
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_unref(UISelect), {
                        id: "book-appt-selected-calendar",
                        value: inputValue.value,
                        "onUpdate:value": [
                            _cache[0] || (_cache[0] = ($event) => ((inputValue).value = $event)),
                            _cache[1] || (_cache[1] = (key, value) => setBlockedOption(key, value))
                        ],
                        options: blockedOffDropdownOptions.value,
                        filterable: true,
                        placeholder: _ctx.$t('common.select_one')
                    }, null, 8, ["value", "options", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('appointmentModal.appointment_title')), 1),
                    _createVNode(_unref(UIInput), {
                        value: _unref(appointmentWizardState).blockedOffTitle,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((_unref(appointmentWizardState).blockedOffTitle) = $event)),
                        placeholder: _ctx.$t('appointmentModal.appointment_title_placeholder'),
                        id: "appointment-title-input"
                    }, null, 8, ["value", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('appointmentModal.date_time')), 1),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('appointmentModal.slots_title')), 1),
                    _createVNode(_unref(UISelect), {
                        id: "select-timezone-dropdown",
                        value: _unref(appointmentWizardState).selectedTimezone,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((_unref(appointmentWizardState).selectedTimezone) = $event)),
                        options: _unref(computedTimezonesNew),
                        filterable: true,
                        placeholder: _ctx.$t('common.select_one')
                    }, null, 8, ["value", "options", "placeholder"]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                                _hoisted_11,
                                _createVNode(_unref(UIDatepicker), {
                                    id: "custom-start-time",
                                    type: "datetime",
                                    value: _unref(moment)(_unref(appointmentWizardState).blockedOffStartTime).valueOf(),
                                    "parse-date": parseDate,
                                    "is-time-disabled": ts => isTimeDisabled(ts, true),
                                    "is-date-disabled": ts => isDateDisabled(ts, true),
                                    format: "PP p",
                                    "time-picker-props": {
                                        format: 'h:mm a',
                                        use12Hours: true,
                                    },
                                    "onUpdate:value": _unref(updateStartTime),
                                    placeholder: _ctx.$t('appointmentModal.select_time')
                                }, null, 8, ["value", "is-time-disabled", "is-date-disabled", "onUpdate:value", "placeholder"])
                            ]),
                            _createElementVNode("div", null, [
                                _hoisted_12,
                                _createVNode(_unref(UIDatepicker), {
                                    id: "custom-end-time",
                                    type: "datetime",
                                    "is-date-disabled": ts => isDateDisabled(ts, false),
                                    value: _unref(moment)(_unref(appointmentWizardState).blockedOffEndTime).valueOf(),
                                    "parse-date": parseDate,
                                    "onUpdate:value": _unref(updateEndTime),
                                    "is-time-disabled": ts => isTimeDisabled(ts, false),
                                    format: "PP p",
                                    "time-picker-props": {
                                        format: 'h:mm a',
                                        use12Hours: true,
                                    },
                                    placeholder: _ctx.$t('appointmentModal.select_time')
                                }, null, 8, ["is-date-disabled", "value", "onUpdate:value", "is-time-disabled", "placeholder"])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
